"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACEmpty = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var ACEmpty = function (props) { return ((0, jsx_runtime_1.jsx)(antd_1.Empty, { image: (props === null || props === void 0 ? void 0 : props.showImage) &&
        'https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg', styles: { image: { height: 100 } }, className: props === null || props === void 0 ? void 0 : props.className, description: (0, jsx_runtime_1.jsx)("p", { children: (props === null || props === void 0 ? void 0 : props.description) || 'No data found' }) })); };
exports.ACEmpty = ACEmpty;
